import React, { useState, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form, Col } from 'react-bootstrap';
import Button from '../../../../components/Button';
import If from '../../../../components/If';
import AlertError from '../../../../components/AlertError';
import AlertSuccess from '../../../../components/AlertSuccess';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import { STRINGS } from '../../../../util/strings';
import { STRINGS_CIBIO } from '../../../../util/authorizationsCIBIO/string';
import { AutorizacaoCibioGrupoVisualizacaoForm, AutorizacaoCibioGrupoVisualizacaoUsuariosForm } from '../../../../models/modelsAuthorizationsCIBIO';
import { isEmptyObj } from '../../../../functions/isEmptyObject';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import AddButton from '../../../../components/AddButton';
import DeleteButton from '../../../../components/DeleteButton';
import Modal from '../../../../components/Modal';
import api from '../../../../services/api';
import '../../styles_add.scss';

export default function GrupoVisualizacao() {
	const history = useHistory();
	const [loading, setLoading] = useState<boolean>(false);
	const [success, setSuccess] = useState<boolean>(false);
	const [error, setError] = useState<any>(null);
	const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
	const [usuarios, setUsuarios] = useState<AutorizacaoCibioGrupoVisualizacaoUsuariosForm[]>([]);
	const [modalAtivo, setModalAtivo] = useState<boolean>(false);


	const grupoVisualizacaoSchema = yup.object().shape({
		nome: yup
			.string()
			.required(STRINGS.FORM_FIELD_REQUIRED),
		descricao: yup
			.string()
			.required(STRINGS.FORM_FIELD_REQUIRED),
		ativo: yup
			.boolean()
	})

	const initialValues: AutorizacaoCibioGrupoVisualizacaoForm = {
		nome: '',
		descricao: '',
		ativo: true,
	}

	const { register, errors, handleSubmit, getValues, formState: { isDirty } } = useForm({
		defaultValues: initialValues,
		mode: 'onTouched',
		resolver: yupResolver(grupoVisualizacaoSchema)
	})

	const { getValues: getValuesUsuario, control: controlUsuario, register: registerUsuario, errors: errorsUsuario, handleSubmit: handleSubmitUsuario, trigger: triggerUsuario, watch: watchUsuario } = useForm({
		mode: 'all'
	})


	const verifyErrorsOnForm = (): string[] => {
		let errorsForm: any[] = [];

		if (!isEmptyObj(errors)) {
			Object.entries(errors).map(err => errorsForm.push(err[0]));
		}
		return errorsForm;
	}

	const onSubmitUsuario = (info: any): void => {

		setModalAtivo(false);

		setUsuarios([...usuarios, {
			usuario: getValues('emailUsuario')
		}]);
	}


	const acoesUsuarios = (props: any) => (
		<Fragment>
			<DeleteButton onClick={() => {
				setUsuarios([]);
				let arr: any = [];
				const { node } = props;

				node.gridApi.updateRowData({ remove: [node.data] })

				node.gridApi.forEachNode(({ data }: any) => arr.push(data));
				setUsuarios([...arr]);
			}} />
		</Fragment>
	)    


	const onSubmit = async () => {
		setLoading(true);
		setError(null);

		try {
			const { status } = await api.post('/api/v1/autorizacoes-cibio/AutorizacaoCibioGrupoVisualizacao/adicionargrupo', {
				nome: getValues('nome'),
				descricao: getValues('descricao'),
				ativo: true,

				usuarios: usuarios,
			});

			if (status === 201) {
				setSuccess(true);

				setTimeout(() => {
					history.goBack();
				}, 3500);
			}
		} catch (error: any) {
			setError(error?.response?.data);
		}
		setLoading(false);
	}

	return <div className="container container-fluid">
		<If condition={verifyErrorsOnForm()}>
			{verifyErrorsOnForm().map(item => <AlertError message={`O campo ${item} é obrigatório`} />)}
		</If>
		<If condition={success && !error}>
			<AlertSuccess
				message={STRINGS.ALERT_MESSAGE_SUCCESS}
			/>
		</If>
		<If condition={!success && error !== null}>
			{error !== null && error.message.length > 0 ? error.message.map((errorE: string) => <AlertError message={errorE} />) : <AlertError message={STRINGS.ALERT_GENERIC_ERROR} />}
		</If>
		<h3>{STRINGS_CIBIO.REGISTER_VIEW_GROUP}</h3>
		<Form onSubmit={handleSubmit(onSubmit)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Nome do Grupo<em>*</em>
					</Form.Label>
					<Form.Control
						ref={register}
						name="nome"
						type="text"
						placeholder="Insira o nome do grupo"
						isInvalid={errors.nome !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.nome}>
						<Form.Control.Feedback type="invalid">
							{errors.nome?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Descrição do Grupo<em>*</em>
					</Form.Label>
					<Form.Control
						ref={register}
						name="descricao"
						as="textarea"
						rows={5}
						placeholder="Insira a descrição do grupo"
						isInvalid={errors.descricao !== undefined}
						autoComplete="off"
					/>
					<If condition={errors.descricao}>
						<Form.Control.Feedback type="invalid">
							{errors.descricao?.message}
						</Form.Control.Feedback>
					</If>
				</Form.Group>
			</Form.Row>
			<Form.Row className="row-custom">
				<Form.Group as={Col}>
					<Form.Label>
						Usuários do grupo
						<AddButton type="button" onClick={() => setModalAtivo(true)} />
					</Form.Label>
				</Form.Group>
			</Form.Row>
			<If condition={usuarios?.length}>
				<div className="ag-theme-alpine" style={{ height: '210px', width: '100%' }}>
					<AgGridReact
						rowData={usuarios}
						defaultColDef={{ flex: 1, sortable: true, resizable: true, cellStyle: { justifyContent: 'center', alignItems: 'center' } }}
						gridOptions={{ headerHeight: 80 }}
						stopEditingWhenGridLosesFocus={true}
						singleClickEdit={true}
						frameworkComponents={{
							actions: acoesUsuarios
						}}
					>
						<AgGridColumn
							headerName='Usuário'
							field="usuario"
							cellStyle={{
								justifyContent: 'left'
							}}
							autoHeight
							wrapText
							minWidth={250}
						/>
						<AgGridColumn
							headerName="Ações"
							cellRenderer="actions"
							maxWidth={100}
						/>
					</AgGridReact>
				</div>
			</If>                            

			<div className="button-position">
				<Button
					title="Cancelar"
					type="button"
					contained={false}
					onClick={() => {
						isDirty ? setIsConfirmation(true) :
							history.goBack();
					}}
				/>
				<Button
					title="Cadastrar"
					type="submit"
					contained={true}
					isLoading={loading}
				/>
			</div>
		</Form>
		<If condition={isConfirmation}>
			<ConfirmationModal
				show={isConfirmation}
				confirmationMsg={STRINGS_CIBIO.CONFIRM_LEFT_EDITION}
				cancelMsg={STRINGS_CIBIO.CANCEL_LEFT_EDITION}
				onConfirm={() => history.goBack()}
				onHide={() => setIsConfirmation(false)}
				title={STRINGS_CIBIO.EDITION_TITLE_CONFIRMATION}
				type="button"
				variant="danger"
			>
				{STRINGS_CIBIO.EDITION_REGISTER_CONFIRMATION_CANCEL}
			</ConfirmationModal>
		</If>

		<If condition={modalAtivo}>
			<Modal
				show={true}
				onHide={() => setModalAtivo(false)} title={'Adicionar usuário'}>
				<Form onSubmit={handleSubmitUsuario(onSubmitUsuario)} autoComplete="off">
					<Form.Row className="row-custom">
						<Form.Group as={Col}>
							<Form.Label>
								E-Mail do Usuário
							</Form.Label>
							<Form.Control
								ref={register}
								name="emailUsuario"
								placeholder="Insira o e-mail do usuário"
							/>
						</Form.Group>
					</Form.Row>

					<div className="button-position">
						<Button title="Cancelar" contained={false} type="button" onClick={() => setModalAtivo(false)} />
						<Button
							title="Salvar"
							contained={true}
							type="button"
							onClick={() => {
								handleSubmitUsuario(onSubmitUsuario)();
							}}
						/>

					</div>
				</Form>
			</Modal>
		</If>

	</div>;
}